import { IItemOfProfessions } from '@ucheba/store/professions/id/types'
import { useCallback, useMemo } from 'react'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { useRouter } from 'next/router'

interface IProgramType {
  value: number[] | number
  name: string
}

interface IUseProfByIdCore {
  (
    props: IItemOfProfessions | null,
    availableProgramTypes: EProgramTypes[]
  ): {
    title: string | null
    convertCaseName: (name?: string | null) => string
    programTypes: IProgramType[]
    params: {
      [key: string]: string | string[] | EProgramTypes[]
    }
  }
}

export const getAvailableProgramTypes = (
  profession: IItemOfProfessions | null
): EProgramTypes[] => {
  const availableProgramTypes: EProgramTypes[] = []

  if (profession?.stats?.universitiesCount) {
    availableProgramTypes.push(EProgramTypes.higher)
  }

  if (profession?.stats?.collegesCount) {
    availableProgramTypes.push(EProgramTypes.vocational)
  }

  if (profession?.stats?.coursesCount) {
    availableProgramTypes.push(EProgramTypes.course)
  }
  return availableProgramTypes
}

export const useProfByIdCore: IUseProfByIdCore = (props) => {
  const { name: nameProf } = props || {}

  const { query } = useRouter()

  const convertCaseName = useCallback((name?: string | null) => {
    if (name) {
      const str = name
      const secondLetter = name[1]

      if (secondLetter === secondLetter.toUpperCase()) {
        return str
      }

      const newStr = str
        .split('')
        .map((letter, key) => (key === 0 ? letter.toLowerCase() : letter))
        .join('')

      return newStr
    }

    return ''
  }, [])

  const title = useMemo(() => {
    if (nameProf) {
      return `Профессия ${convertCaseName(nameProf)}`
    }

    return null
  }, [nameProf, convertCaseName])

  const programTypes = useMemo(() => {
    const availableProgramTypes = getAvailableProgramTypes(props)
    return availableProgramTypes.map((availableType) => {
      switch (availableType) {
        case EProgramTypes.higher:
          return {
            value: availableType,
            name: 'Вузы',
          }
        case EProgramTypes.vocational:
          return {
            value: availableType,
            name: 'Колледжи',
          }
        case EProgramTypes.course:
          return {
            value: availableType,
            name: 'Курсы',
          }
        default:
          throw new Error('Unknown program type')
      }
    })
  }, [props])

  const params = useMemo(() => {
    if (query['topProgramTypes[]']) {
      return {
        ...query,
        programTypes: query['topProgramTypes[]'],
      }
    }

    return {
      ...query,
      'programTypes[]': [
        EProgramTypes.vocational,
        EProgramTypes.vocationalSpo,
        EProgramTypes.vocationalNpo,
        EProgramTypes.higher,
        EProgramTypes.higherBachelor,
        EProgramTypes.higherSpeciality,
        EProgramTypes.master,
        EProgramTypes.aspirant,
      ],
    }
  }, [query])

  return {
    title,
    convertCaseName,
    programTypes,
    params,
  }
}
